import {Utils} from "../../../../../shared/utils/utils";

export class BandwidthData {
  public bandwidth: any;

  constructor(bandwidth: number) {
    this.bandwidth = {
      display: Utils.sizeToString(bandwidth),
      value: bandwidth
    };
  }
}
